document.addEventListener("DOMContentLoaded", function() {
    const textBlocks = document.querySelectorAll('.metaRelatedProducts_textBlockDescriptionContent');

    textBlocks.forEach(textBlock => {
        const paragraphs = textBlock.querySelectorAll('p');
        const button = textBlock.querySelector('.metaRelatedProducts_textBlockDescriptionButton');
        const maxLines = 6;
        let hiddenParagraphs = [];

        paragraphs.forEach((paragraph, index) => {
            if (index >= maxLines) {
                paragraph.style.display = 'none';
                hiddenParagraphs.push(paragraph);
            }
        });

        if (hiddenParagraphs.length > 0) {
            button.style.display = 'flex';

            button.addEventListener('click', function() {
                if (button.classList.contains('active')) {
                    hiddenParagraphs.forEach(paragraph => {
                        paragraph.style.display = 'none';
                    });
                    button.innerHTML = 'SHOW MORE ' + button.querySelector('svg').outerHTML;
                    button.classList.remove('active');
                } else {
                    hiddenParagraphs.forEach(paragraph => {
                        paragraph.style.display = 'block';
                    });
                    button.innerHTML = 'SHOW LESS ' + button.querySelector('svg').outerHTML;
                    button.classList.add('active');
                }
            });
        }
    });
});